export enum EstateDetailsMainTabValue {
  SUMMARY = 'summary',
  NOTES = 'notes',
  TASKS = 'tasks',
  DOCUMENTS = 'documents',
  ACTIVITIES = 'activities',
  STEPS = 'steps',
  INBOX = 'inbox',
  TAX_MODULE = 'taxModule',
  SNAPSHOT = 'snapshot',
  ANNUAL_REVIEW = 'annualReview'
}
